import { render, staticRenderFns } from "./DsnPanel.vue?vue&type=template&id=4a79af43&"
import script from "./DsnPanel.vue?vue&type=script&lang=js&"
export * from "./DsnPanel.vue?vue&type=script&lang=js&"
import style0 from "./DsnPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports